module.exports = __webpack_public_path__ + "static/media/rentBackground.6cbd00bf.png";